import type { ExportResultsRequest, ExportResultsResult } from '../../../../types/resultsExport';

/**
 * Helper to track export events (fire-and-forget pattern for non-React contexts).
 * `skip_identity` rides along on SQL INSERT exports only — it's meaningless for
 * the other formats and would just add noise.
 */
function trackExportEvent(request: ExportResultsRequest): void {
  if (typeof window === 'undefined') return;
  if (!window.electronAPI?.analytics?.track) return;

  const props: Record<string, string | number | boolean | null> = { format: request.format };
  if (request.format === 'sql') {
    props.skip_identity = request.identityMode === 'exclude';
  }

  window.electronAPI.analytics.track('feature:export_results', props).catch(() => {
    // Silently ignore analytics errors
  });
}

export async function exportResults(request: ExportResultsRequest): Promise<ExportResultsResult> {
  if (!window.electronAPI?.exportResults) {
    return { success: false, error: 'Export API is unavailable' };
  }

  const result = await window.electronAPI.exportResults(request);

  // Track successful exports
  if (result.success) {
    trackExportEvent(request);
  }

  return result;
}

